import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ToggleSwitch from "src/Components/FormElements/ToggleSwitch";
import { restApiRequest, REPORT_SERVICE } from "src/utils/Api";
import isMockView from "src/utils/Api/isMockView";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import SUBSCRIPTION_METHODS from "src/utils/constants/subscriptionMethods";
import { useLanguages } from "src/utils/Languages/LanguageContext";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";
import DynamicParametersDescription from "src/Pages/Report/NewReport/ReportsList/Report/dynamicParametersDescription";
import SubscriptionForm from "./subscriptionForm";
import {
  subscribeMethodMock,
  subscribeFrequencyMock,
  formatDropdownMock,
  ahrsDropdownMock,
} from "./mockData";

const Subscription = ({
  isEdit,
  subscribeFunc,
  subscribeData,
  reportId,
  companyId,
  isSaving,
  setIsSaving,
  setSubscribeDataToEditSend,
  isGetBlockBtn,
  isAhr,
  isdateOK,
  changeSwitchSendReport,
  parametersDynamic,
  parametersState,
  parameters,
  checkSub,
  setCheckSub,
  subscriptionDto,
  setSubscriptionDto,
  isMultisheet,
}) => {
  const [subscribeInfo, setsubscribeInfo] = useState(subscribeData);
  const [subscribeInfoModal, setsubscribeInfoModal] = useState(subscribeData);

  const [subscribeMethodOptions, setSubscribeMethodOptions] = useState([]);
  const [formatOptions, setFormatOptions] = useState([]);
  const [ahrsList, setAhrsList] = useState([]);
  const [isToken, setisToken] = useState(false);
  const [parametersDynamicInside, setParametersDynamicInside] =
    useState(parametersDynamic);

  useEffect(() => {
    fetchIsTokenValid();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setParametersDynamicInside(parametersDynamic);
  }, [parametersDynamic]);

  useEffect(() => {
    if (isEdit) {
      setSubscribeDataToEditSend(subscribeInfo);
    }
  }, [isEdit, subscribeInfo, setSubscribeDataToEditSend]);

  const clickSubscribe = () => {
    try {
      setIsSaving(true);
      if (isAhr) {
        const subInfo = { ...subscribeInfo };
        subInfo.subscribeMethod.recipients = [];
        setsubscribeInfo(subInfo);
      }
      const data = subscribeInfo;
      subscribeFunc(data);
    } catch (error) {
      setIsSaving(false);
    }
    setIsSaving(false);
  };

  const fetchIsTokenValid = async () => {
    const endpointToken = `/reportgroups/checkToken/${companyId}`;
    fetchData(setisToken, endpointToken, REPORT_SERVICE, "GET", {});
  };

  function PrepareDynamicParameters(isOn) {
    if (typeof changeSwitchSendReport === "function") {
      changeSwitchSendReport(isOn);
    }
  }

  return (
    <>
      <div className="row">
        <DynamicParametersDescription
          parametersDynamic={parametersDynamicInside}
          isOpen={checkSub}
        />
        {checkSub && (
          <SubscriptionForm
            clickSubscribe={clickSubscribe}
            isEdit={isEdit}
            isSaving={isSaving}
            isGetBlockBtn={isGetBlockBtn}
            isTokenAvailable={isToken}
            isdateOK={isdateOK}
            parametersState={parametersState}
            parameters={parameters}
            companyId={companyId}
            subscriptionDto={subscriptionDto}
            setSubscriptionDto={setSubscriptionDto}
            isMultisheet={isMultisheet}
          />
        )}
      </div>
    </>
  );
};

Subscription.propTypes = {
  isEdit: PropTypes.bool,
  subscribeFunc: PropTypes.func.isRequired,
  subscribeData: PropTypes.object.isRequired,
  reportId: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  setIsSaving: PropTypes.func.isRequired,
  setSubscribeDataToEditSend: PropTypes.func.isRequired,
  isAhr: PropTypes.bool,
  isGetBlockBtn: PropTypes.bool.isRequired,
  isdateOK: PropTypes.func.isRequired,
  changeSwitchSendReport: PropTypes.func,
  parametersDynamic: PropTypes.array.isRequired,
  parametersState: PropTypes.array.isRequired,
  parameters: PropTypes.array.isRequired,
  checkSub: PropTypes.bool.isRequired,
  setCheckSub: PropTypes.func.isRequired,
  subscriptionDto: PropTypes.object.isRequired,
  setSubscriptionDto: PropTypes.func.isRequired,
  isMultisheet: PropTypes.bool.isRequired,
};

Subscription.defaultProps = {
  changeSwitchSendReport: null,
  isAhr: false,
  isEdit: false,
};

export default Subscription;

const fetchData = async (
  updateData,
  endpoint,
  service,
  method,
  { headers, params, body },
  mockData,
  error
) => {
  if (isMockView()) {
    updateData(mockData);
  } else {
    try {
      const result = await restApiRequest(
        service,
        endpoint,
        method,
        { headers, params, body },
        {}
      );
      updateData(result);
    } catch (e) {
      console.error(e);
      newRelicErrorReport(
        e,
        "Pages/Report/NewReport/ReportsList/Report/Subscription/index.js - 332"
      );
      dynamicNotification(error || e.message || "błąd", "error");
    }
  }
};
